import type { SuretyBond } from "@portal/api/bond/agent";
import type { UseFollowersReturn } from "@portal/api/followers";
import { AgentFollowToggle } from "@portal/components/features/followers/AgentFollowToggle";
import { cn } from "@portal/components/lib/utils";
import { getStatusTagByBondStatus } from "@portal/components/ui/StatusTag";
import { TruncatedLabel } from "@portal/components/ui/TruncatedLabel";
import type { FC } from "react";
import { formatDisplayTitle } from "../../../utils";

export type AgentBondStickyPanelProps = {
	bond: SuretyBond;
	followersControl: UseFollowersReturn;
	/** Commercial surety off: this row is the only chrome, so keep every piece. */
	alwaysShow?: boolean;
};

export const AgentBondStickyPanel: FC<AgentBondStickyPanelProps> = ({
	bond,
	followersControl,
	alwaysShow = false,
}) => {
	return (
		<div
			data-testid="agent-bond-sticky-panel"
			className="flex items-center gap-3 whitespace-nowrap"
		>
			<TruncatedLabel
				label={`${formatDisplayTitle(bond.displayTitle)} · ${bond.principalName}`}
				className={cn(
					"max-w-[240px] text-[12px] font-[550] text-secondary",
					!alwaysShow && "hidden xl:block",
				)}
			/>
			<div data-testid="agent-bond-sticky-status" className={cn(!alwaysShow && "hidden xs:block")}>
				{getStatusTagByBondStatus(bond.status, { iconOnly: true })}
			</div>
			<div
				data-testid="agent-bond-sticky-followers"
				className={cn(!alwaysShow && "hidden sm:flex", alwaysShow && "flex")}
			>
				<AgentFollowToggle
					isFollowing={followersControl.isFollowing}
					followers={followersControl.followers}
					onFollow={() => followersControl.createAgentFollower(undefined)}
					onUnfollow={() => followersControl.removeAgentFollower(undefined)}
					trackingId="bond-agent-follow-sticky"
					followLabel="Follow this bond"
					unfollowLabel="Unfollow this bond"
				/>
			</div>
		</div>
	);
};
